<template>
    <div class="formpin">
        <v-card-text class="pa-0">
            <v-form class="ldmx-form" @submit.prevent="generatePin()" autocomplete="off">
                <table cellpadding="5px">
                    <tr class="fade-in two">
                        <td align="right"><v-label>Enter PIN</v-label></td><td width="5px"></td>
                        <td width="150px">
                            <v-label>  
                                <v-text-field
                                    data-vv-name="pin_no"
                                    data-vv-as="PIN Number"
                                    v-validate="{required:'pinGenerateForm.pin_no',numericOnlyCheck:'pinGenerateForm.pin_no',pinMinDigitsCheck:4,pinMaxDigitsCheck:4}"
                                    v-model="pinGenerateForm.pin_no"
                                    :error-messages="errors.collect('pin_no')"
                                    maxlength="4"
                                    onkeydown="javascript: return (event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 13 || (event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105)) ? true : false"
                                ></v-text-field>
                            </v-label>
                        </td>
                    </tr>
                    <tr class="fade-in two">
                        <td align="right"><v-label>Confirm PIN</v-label></td><td width="5px"></td>
                        <td width="150px">
                            <v-label>  
                                <v-text-field
                                    data-vv-name="confirm_pin_no"
                                    data-vv-as="Confirm PIN Number"
                                    v-validate="{required:'pinGenerateForm.confirm_pin_no',numericOnlyCheck:'pinGenerateForm.pin_no',pinMinDigitsCheck:4,pinMaxDigitsCheck:4,confirmPinCheck: [pinGenerateForm.pin_no]}"
                                    v-model="pinGenerateForm.confirm_pin_no"
                                    :error-messages="errors.collect('confirm_pin_no')"
                                    maxlength="4"
                                    onkeydown="javascript: return (event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 13 || (event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105)) ? true : false"
                                >
                                </v-text-field>
                            </v-label>
                        </td>
                    </tr>
                    <tr class="fade-in two">
                        <td><v-label> </v-label></td><td width="5px"></td>
                        <td>
                            <v-btn color="orange  white--text" type="submit">Create</v-btn>
                        </td>
                    </tr>           
                </table>
            </v-form>
        </v-card-text>
    </div>
</template>
<script>
import config from "../config";
import utils from "../util";
import services from "../services/HttpService";
import { Validator } from 'vee-validate';
import { mapActions } from "vuex";
import { setTimeout } from 'timers';
Validator.extend('pinMinDigitsCheck', {
    getMessage: field => 'The field ' + field + ' may not be less than 4 digits.',
    validate: function (value) {
        if (value.toString().length < 4) {
            return false;
        }
        return true;
    }
});
Validator.extend('pinMaxDigitsCheck', {
    getMessage: field => 'The field ' + field + ' may not be greater than 4 digits.',
    validate: function (value) {
        if (value.toString().length > 4) {
            return false;
        }
        return true;
    }
});
Validator.extend('confirmPinCheck', {
    getMessage: field => config.confirmPinNoValidationMsg,
    validate: function (value, [pinNumber]) {
        if(value.toString() != pinNumber.toString()){
            return false;
        }
        return true;
    }
});
Validator.extend('numericOnlyCheck', {
    getMessage: field => 'The field ' + field + ' accepts only digits.',
    validate: function (value) {
        let regex = /^[0-9]*$/
        if (!regex.test(value)) {
            return false;
        }
        return true;
    }
});
export default {
    data: () => ({
        pinGenerateForm: {
            pin_no: "",
            confirm_pin_no: ""
        }
    }),
    created() {
        const self = this;
        self.utils = utils;
    },
    methods: {
        ...mapActions(["updateLoggedInPin"]),
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        generatePin(){
            const self = this,
                wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });
            self.$validator.validateAll().then(isValid => {
                if (isValid) {
                    wApp.$emit("showLoader", {
                        show: true
                    });
                    //delete self.pinGenerateForm["confirm_pin_no"];
                    services.post("users/generate-pin", self.pinGenerateForm, {Authorization: "Bearer " + this.$store.state.user.token})
                    .then(async res => {
                        wApp.$emit("showLoader", {
                            show: false
                        });
                        if (res.data.status) {
                            self.updateLoggedInPin({pin: self.pinGenerateForm["pin_no"]});
                            self._showToast(config.pinGenerateSuccessMsg, config.successMsgColorStr);
                            setTimeout(()=>{
                                self.$router.go();    
                            },1000);
                        }else{
                            self._showToast(res.data.message, config.errMsgColorStr);
                            return false;
                        }
                    })
                    .catch(err => {
                        wApp.$emit("showLoader", {
                            show: false
                        });
                        return false;
                    });
                }
            })
            .catch(e => {
                wApp.$emit("showLoader", {
                show: false
                });
                return false;
            });
        }
    }
}
</script>
<style>
</style>




// WEBPACK FOOTER //
// src/components/GeneratePin.vue